import './Home.css';
import '../header/GlobalButton.css'

const Home = () => {

  return (
    <div class="max-h-[calc(100vh-86px)] overflow-y-none flex flex-col justify-between">
        <header class="relative bg-stone-200 min-h-[50vh] flex items-center justify-center text-center px-4 py-12">
            <div class="absolute inset-0 bg-stone-300 opacity-40 flex items-center justify-center text-stone-400 font-serif italic tracking-wide">
                [Immagine Hero di Copertina]
            </div>
            <div class="relative z-10 max-w-2xl space-y-4">
                <span class="text-xs uppercase tracking-widest text-stone-600 font-semibold">Alta Sartoria Contemporanea</span>
                <h1 class="text-4xl font-serif tracking-wide text-stone-900 leading-tight">L'eleganza si cuce nel silenzio.</h1>
                <p class="text-stone-600 max-w-md mx-auto italic text-sm">Capi senza tempo realizzati a mano con fibre naturali e geometrie essenziali.</p>
                <div class="pt-2">
                    <a href='#collezione' className="button button--janus"><span>Scopri la Collezione</span></a>
                </div>
            </div>
        </header>

        <main class="max-w-6xl mx-auto w-full px-4 py-12 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div class="space-y-2">
                <h2 class="text-2xl font-serif tracking-wide text-stone-900">La nostra filosofia</h2>
                <p class="text-stone-600 text-sm leading-relaxed">
                    Crediamo in una moda che non segue il ritmo frenetico delle stagioni, ma il valore dell'attesa. Ogni creazione nasce da un dialogo intimo tra il tessuto e il corpo.
                </p>
                <div class="flex gap-4 pt-2 text-xs uppercase tracking-wider font-semibold">
                    <a href="#atelier" class="text-stone-900 hover:underline">Atelier →</a>
                    <a href="#comeNasce" class="text-stone-900 hover:underline">Processo →</a>
                </div>
            </div>
            <div class="bg-stone-200 aspect-video w-full flex items-center justify-center text-stone-500 font-serif italic border border-stone-200">
                [Dettaglio Tessuto]
            </div>
        </main>
    </div>
  );
};

export default Home;
